export const getProfileData = (store) => store.profile.data;
